if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      //this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      let fetchLink = `${routes.cart_add_url}`;
      const config = fetchConfig('javascript');

      if (document.querySelector("[data-bundle]")) {
        const body = {};
        const items = [];
        const timestamp = Date.now();
        fetchLink = `${routes.cart_add_url}.js`

        document.querySelectorAll("[data-bundle] [data-option]").forEach(option => {
          const optionId = parseInt(option.dataset.option);
          const optionQuantity = parseInt(option.querySelector("input").value);

          if (optionQuantity > 0) {
            items.push({
              id: optionId,
              quantity: optionQuantity,
              properties: {
                "_ts_bundle": `${timestamp}`
              }
            }) 
          }
        })

        if (document.querySelector("[name='purchase_option'][value='subscription']:checked")) {
          const giftId = document.querySelector("[data-bundle]").dataset.gift;
          const additionalGiftId = document.querySelector("[data-bundle]").dataset.additionalGift;

          items.forEach(item => {
            item["selling_plan"] = parseInt(document.querySelector("[name='selling_plan']").value)
          })
          
          if (giftId && giftId !== "") {
            items.push({
              id: giftId,
              quantity: 1,
              properties: {
                "_ts_gift": `${timestamp}`
              }
            })
          }

          if (additionalGiftId && additionalGiftId !== "") {
            items.push({
              id: additionalGiftId,
              quantity: 1,
              properties: {
                "_ts_gift": `${timestamp}`
              }
            })
          }
        }

        body["items"] = items;
        body["sections"] = this.cart.getSectionsToRender().map((section) => section.id);
        body["sections_url"] = window.location.pathname;
        config.body = JSON.stringify(body);
      } else {
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;
      }
      
      fetch(fetchLink, config)
        .then((response) => response.json())
        .then((response) => {
          if (document.querySelector("[data-bundle]")) {
            window.location.href = window.location.origin + "/checkout";
            return;
          }

          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error && typeof formData !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          //this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
